import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";

const CURRICULUM = [
  "Python Basics, OOP, File I/O",
  "Frontend (HTML, CSS, JavaScript, ReactJS)",
  "Backend (Flask, Django)",
  "Database (SQL, PostgreSQL, MongoDB)",
  "Data Science (NumPy, Pandas, ML Libraries)",
  "Cloud Deployment, Web Scraping, Microservices",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive hands-on training with expert mentors." },
  { title: "Mock Interview",                 desc: "Score minimum 3.5 out of 5 to progress." },
  { title: "Live Project — 3 Months",        desc: "Work on real industry-grade projects." },
  { title: "Monthly Assessment & Report",    desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Certification and job opening references." },
];
const PythonFullstack = () => (
  <CourseDetailTemplate title="Python Fullstack Course"
    description="Develop dynamic web applications with Python. Master Python programming, Django for robust backend development, and React for responsive front-end development — culminating in a comprehensive skillset to build, integrate, and deploy cloud-ready applications."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["Python", "Django", "Flask", "ReactJS", "PostgreSQL"]}
    programName="Python Fullstack Course"
  />
);
export default PythonFullstack;
